import Vue from 'vue'
import HowItWorks from "./views/HowItWorks";
import "@afrihost/vue-signup/dist/afrihost-signup.css";
import Signup from "@afrihost/vue-signup";
import PrepaidPackages from './views/PrepaidPackages'
import VueScrollTo from 'vue-scrollto'
import { VueHammer } from 'vue2-hammer'
import store from './store/index'
import router from "../../main/js/router";
import CoverageCheck from "../../main/js/views/CoverageCheck";

import GoogleReviewsPlugin from '@afrihost/google-reviews';
import "@afrihost/google-reviews/dist/google-reviews.css";

import axios from "axios";
const signalInstance = axios.create({
	baseURL: 'https://signal.afrihost.com/api/',
	withCredentials: true,
	headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/json',
	}
})

if(window && process.env.MIX_SIGNAL_UUID) {


	const searchParams = new URLSearchParams(window.location.search);

	// signal page view
	let l = window.location
	let path = l.pathname
	let source = searchParams.get('utm_source')
	let medium = searchParams.get('utm_medium')
	let campaign = searchParams.get('utm_campaign')

	let event = {
		type: 'page-view',
		value: null,
		path: path,
		meta: null,
		campaign: campaign,
		medium: medium,
		source: source
	}

	signalInstance.post(`/public/project/${process.env.MIX_SIGNAL_UUID}/event`, event)

}

store.commit('providers/updateProviders', window._providers)

Vue.use(Signup, {
	store: store,
	storeKey: process.env.MIX_SIGNUP_PLUGIN_STORE_KEY,
	solutionTypes: ['composite_fibre'],
	upsellSolutionTypes: ['connectivity_mobile'],
	googleMapsKey: 'AIzaSyB_jNrg_FCQ8F-nLgBhRNb9149pqIkIggo',
	pageRequestedFrom: process.env.MIX_SIGNUP_PLUGIN_PAGE_REQUESTED_FROM,
	testSignup: process.env.MIX_SIGNUP_PLUGIN_TEST === "true",
	decoInStock: {
		twoPack: process.env.MIX_SIGNUP_PLUGIN_DECO_2_IN_STOCK === "true",
		threePack: process.env.MIX_SIGNUP_PLUGIN_DECO_3_IN_STOCK === "true",
	},
	fibreFreeze: process.env.MIX_SIGNUP_PLUGIN_FIBRE_FREEZE === "true",
	fibreTypeScope: 'fibre_prepaid', // fibre_uncapped_pure
	signalUuid: process.env.MIX_SIGNAL_UUID
})

Vue.use(VueScrollTo, {
	container: "body",
	duration: 500,
	easing: "ease",
	offset: -60,
	force: true,
	cancelable: true,
	onStart: false,
	onDone: false,
	onCancel: false,
	x: false,
	y: true
});

Vue.use(VueHammer);
VueHammer.config.swipe = {
	direction: 6,
};

Vue.use(GoogleReviewsPlugin, {
	ctaLabel: 'Get Pure Fibre Now',
});

new Vue({
	name: 'search-bar',
	el: '.search-bar',
	store,
	router,
	render: h => h(CoverageCheck)
});

new Vue({
	el: 'google-reviews',
	methods: {
		callback() {
			this.$scrollTo('header');
		}
	}
});

new Vue({
	name: 'signup-modal',
	el: 'signup-modal',
});

new Vue({
	name: 'packages',
	el: 'prepaid-packages',
	store,
	render: h => h(PrepaidPackages)
});

new Vue({
	name: 'signup-bar',
	el: '.signup-bar'
});

new Vue({
	name: 'nav',
	el: 'nav',
	methods: {
		toggle() {
			this.open = !this.open
		}
	},
	data() {
		return {
			open: false
		}
	}
});

new Vue({
	name: 'info-wrapper',
	el: '.info-wrapper',
	render: h => h(HowItWorks)
});

new Vue({
	name: 'selling-points',
	el: '.selling-points',
	data() {
		return {
			assetUrl: window._assetBaseUrl + '/',
			activeTab: 0,
			tabCount: 5
		}
	},
	methods: {
		setActiveTab(tab) {
			this.activeTab = tab;
		},

		nextSlide() {
			if (this.activeTab < this.tabCount - 1) {
				this.activeTab++;
			} else {
				this.activeTab = 0;
			}
		},

		prevSlide() {
			if (this.activeTab > 0) {
				this.activeTab--;
			} else {
				this.activeTab = this.tabCount - 1;
			}
		},

		jumpToSlide(index) {
			this.activeTab = parseInt(index);
		},

		onSwipe(event) {
			switch (event.type) {
				case 'swipeleft':
					this.nextSlide();
					break;
				case 'swiperight':
					this.prevSlide();
					break;
			}
		}
	},
});

new Vue({
	name: 'about-afrihost',
	el: '.about-afrihost',
	data() {
		return {
			slideCount: 3,
			slide: 0
		}
	},
	methods: {

		nextSlide() {
			if (this.slide < this.slideCount - 1) {
				this.slide++;
			} else {
				this.slide = 0;
			}
		},

		prevSlide() {
			if (this.slide > 0) {
				this.slide--;
			} else {
				this.slide = this.slideCount - 1;
			}
		},

		jumpToSlide(index) {
			this.slide = parseInt(index);
		},

		onSwipe(event) {
			switch (event.type) {
				case 'swipeleft':
					this.nextSlide();
					break;
				case 'swiperight':
					this.prevSlide();
					break;
			}
		}

	},
});

Vue.directive('toggle-faq', {
	bind: (el) => {
		el.addEventListener('click', () => {
			el.classList.toggle('is-open');
		});
	}
});

new Vue({
	name: 'help',
	el: '.help',
	methods: {
		usefulToolClick(name, e) {
			if (dataLayer && e) {
				dataLayer.push({
					event: 'Useful_Tools.Click',
					name: name
				});
			}
		},
		supportClick(name, e) {
			if (dataLayer && e) {
				dataLayer.push({
					event: 'Support_Platforms.Click',
					name: name
				});
			}
		},
	}
});
